import { IUsersTableRow } from 'src/components/profileComponents/Common';
import { TypeOfRole } from 'src/typings/user';

export const usersTableRows: IUsersTableRow[] = [
  {
    id: 1, fieldName: 'username', headerName: 'Name & Email', headerAlign: 'left', align: 'left', width: 2, flex: 2,
  },
  {
    id: 2, fieldName: 'role', headerName: 'Role', headerAlign: 'left', align: 'left', width: 1, flex: 1,
  },
  {
    id: 3, fieldName: 'projects', headerName: 'User projects', subHeaderName: '(assigned/total)', headerAlign: 'left', align: 'left', width: 1, flex: 1,
  },
  {
    id: 5, fieldName: 'status', headerName: '', headerAlign: 'right', align: 'right', width: 2, flex: 2.5,
  },
];

export const allOption = { label: 'All', value: '' };

export const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
export const NAME_REGEX = /^[\p{L}](?:[\p{L}'’\- ]*[\p{L}])?$/u;

export const RolesMap: Record<TypeOfRole, string> = {
  [TypeOfRole.superadmin]: 'Super Admin',
  [TypeOfRole.admin]: 'Admin',
  [TypeOfRole.supervisor]: 'Supervisor',
  [TypeOfRole.manager]: 'Manager',
  [TypeOfRole.partner]: 'Partner',
  [TypeOfRole.rootadmin]: 'Root admin',
};
